import { NgModule } from '@angular/core';
import { SharedModule } from '../common/shared.module';
import { AssemblyListComponent } from './assembly/assembly-list/assembly-list.component';
import { AssemblyFormComponent } from './assembly/assembly-form/assembly-form.component';
import { BomFormComponent } from './bill-of-materials/bom-form/bom-form.component';
import { BomListComponent } from './bill-of-materials/bom-list/bom-list.component';
import { CountFormComponent } from './count/count-form/count-form.component';
import { CountListComponent } from './count/count-list/count-list.component';
import { TransferFormComponent } from './transfer/transfer-form/transfer-form.component';
import { TransferListComponent } from './transfer/transfer-list/transfer-list.component';

import { FilterPipeModule } from 'ngx-filter-pipe';
import { DecimalNewPipe } from '../common/DecimalNewPipe';
import {
  CommonModule,
  DatePipe,
  DecimalPipe,
  CurrencyPipe,
} from '@angular/common';
import { TransactionsModule } from './../transactions/transactions.module';
import { ItemSelectComponent } from './resources/item-select/item-select.component';
import { ModalBomSelectComponent } from './resources/modal-bom-select/modal-bom-select.component';
import { ModalItemHistoryComponent } from './resources/modal-item-history/modal-item-history.component';
import { ModalItemSelectComponent } from './resources/modal-item-select/modal-item-select.component';
import {CustomFilterPipe} from '../common/custom-filter.pipe';
import { PrintV2Component } from './resources/print-v2/print-v2.component';
import { AdminModule } from '../admin/admin.module';
import {
  NgbDropdownModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import {ModalSelectItemWithFilterComponent} from './resources/modal-select-item-with-filter/modal-select-item-with-filter.component';
import {InventoryDashboardComponent} from './inventory-dashboard/inventory-dashboard.component';
import {WidgetModule} from '../common/widget/widget.module';
import {ComponentsModule} from '../components.module';

@NgModule({
  declarations: [
    AssemblyListComponent,
    AssemblyFormComponent,
    BomFormComponent,
    BomListComponent,
    CountFormComponent,
    CountListComponent,
    TransferFormComponent,
    TransferListComponent,
    ItemSelectComponent,
    ModalBomSelectComponent,
    ModalItemHistoryComponent,
    ModalItemSelectComponent,
    PrintV2Component,
    ModalSelectItemWithFilterComponent,
    InventoryDashboardComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FilterPipeModule,
    TransactionsModule,
    AdminModule,
    NgbPaginationModule,
    NgbDropdownModule,
    WidgetModule,
    ComponentsModule,
  ],
  exports: [
    ItemSelectComponent,
    ModalBomSelectComponent,
    ModalItemHistoryComponent,
    ModalItemSelectComponent,
  ],
  providers: [DatePipe, DecimalPipe, DecimalNewPipe, CurrencyPipe, CustomFilterPipe],
})
export class InventoryModule {}
